(() => {
  if (window.__LDJ_PRODUCT_LOADED__) return;
  window.__LDJ_PRODUCT_LOADED__ = true;

  const initProduct = (root) => {
    if (!root || root.dataset.initialized === 'true') return;

    const variantsScript = root.querySelector('[data-product-variants]');
    if (!variantsScript) return;

    let variants = [];

    try {
      variants = JSON.parse(variantsScript.textContent);
    } catch {
      return;
    }

    root.dataset.initialized = 'true';

    const groups = [...root.querySelectorAll('[data-option-group]')];
    const price = root.querySelector('[data-product-price]');
    const form = root.querySelector('[data-product-form]');
    const variantInput = root.querySelector('[data-variant-id]');
    const addButton = root.querySelector('[data-add-to-cart]');
    const preorder = root.dataset.preorder === 'true';

    const selected = [];

    let sizeIndex = null;
    let colorIndex = null;
    let selectedColor = null;

    const setSelectedClass = (group, value) => {
      group.querySelectorAll('[data-option-value]').forEach((button) => {
        button.classList.toggle(
          'is-selected',
          button.dataset.optionValue === value
        );
      });
    };

    groups.forEach((group) => {
      const index = Number(group.dataset.optionIndex);
      const name = group.dataset.optionName;
      const buttons = [...group.querySelectorAll('[data-option-value]')];

      if (!buttons.length) return;

      if (name === 'color') {
        colorIndex = index;

        const black =
          buttons.find(
            (button) =>
              button.dataset.optionValue.toUpperCase() === 'BLACK'
          ) || buttons[0];

        selected[index] = black.dataset.optionValue;
        selectedColor = selected[index];

        setSelectedClass(group, selected[index]);

        const label = group.querySelector('[data-color-label]');

        if (label) {
          label.textContent = ` — ${selected[index]}`;
        }
      } else if (name === 'size') {
        sizeIndex = index;
        selected[index] = null;
      } else {
        selected[index] = buttons[0].dataset.optionValue;
        setSelectedClass(group, selected[index]);
      }
    });

    const matchingVariant = (options = selected) => {
      if (options.some((value) => value === null || value === undefined)) {
        return null;
      }

      return variants.find((variant) =>
        variant.options.every(
          (value, index) => value === options[index]
        )
      );
    };

    const updateSizeAvailability = () => {
      if (sizeIndex === null) return;

      const sizeGroup = groups.find(
        (group) => Number(group.dataset.optionIndex) === sizeIndex
      );

      if (!sizeGroup) return;

      sizeGroup.querySelectorAll('[data-option-value]').forEach((button) => {
        const testOptions = [...selected];
        testOptions[sizeIndex] = button.dataset.optionValue;

        const variant = matchingVariant(testOptions);
        const available = Boolean(variant && variant.available);

        button.classList.toggle('is-unavailable', !available);
        button.setAttribute(
          'aria-disabled',
          available ? 'false' : 'true'
        );
      });
    };

    const updateProductState = () => {
      const variant = matchingVariant();

      // Taglia non ancora selezionata
      if (sizeIndex !== null && !selected[sizeIndex]) {
        variantInput.value = '';
        addButton.disabled = true;
        addButton.textContent = 'SELECT A SIZE';
        root.dataset.availabilityState = 'size-required';
        return;
      }

      // Combinazione non riconosciuta
      if (!variant) {
        variantInput.value = '';
        addButton.disabled = true;
        addButton.textContent = 'UNAVAILABLE COMBINATION';
        root.dataset.availabilityState = 'variant-not-found';
        return;
      }

      variantInput.value = variant.id;

      if (price) {
        price.textContent = variant.price;
      }

      // Shopify considera la variante indisponibile
      if (!variant.available) {
        addButton.disabled = true;
        addButton.textContent = 'SOLD OUT';
        root.dataset.availabilityState = 'shopify-unavailable';
        return;
      }

      // Variante acquistabile
      addButton.disabled = false;
      addButton.textContent = preorder
        ? 'PRE-ORDER'
        : 'ADD TO BAG';

      root.dataset.availabilityState = preorder
        ? 'preorder-available'
        : 'available';
    };

    const filterGallery = () => {
      if (colorIndex === null || !selectedColor) return;

      const colorGroup = groups.find(
        (group) => Number(group.dataset.optionIndex) === colorIndex
      );

      if (!colorGroup) return;

      const colors = [
        ...colorGroup.querySelectorAll('[data-option-value]')
      ].map((button) => button.dataset.optionValue.toLowerCase());

      const allMedia = [
        ...root.querySelectorAll(
          '[data-product-media], [data-mobile-media]'
        )
      ];

      const imageColor = (item) => {
        const alt = item.dataset.imageAlt || '';

        return colors.find((color) => alt.includes(color)) || null;
      };

      const hasTaggedImages = allMedia.some((item) => imageColor(item));

      allMedia.forEach((item) => {
        if (!hasTaggedImages) {
          item.dataset.colorVisible = 'true';
          return;
        }

        const color = imageColor(item);

        item.dataset.colorVisible =
          !color || color === selectedColor.toLowerCase()
            ? 'true'
            : 'false';
      });

      root
        .querySelectorAll('[data-product-media]')
        .forEach((item) => {
          item.hidden = item.dataset.colorVisible !== 'true';
        });

      resetMobileGallery();
    };

    const mobileGallery = root.querySelector('[data-mobile-gallery]');
    const mobileCounter = root.querySelector('[data-mobile-counter]');

    let mobileIndex = 0;

    const getVisibleMobileMedia = () =>
      [...root.querySelectorAll('[data-mobile-media]')].filter(
        (item) => item.dataset.colorVisible !== 'false'
      );

    function renderMobileGallery() {
      const visible = getVisibleMobileMedia();

      if (!visible.length) return;

      if (mobileIndex >= visible.length) {
        mobileIndex = 0;
      }

      root.querySelectorAll('[data-mobile-media]').forEach((item) => {
        item.hidden = true;
      });

      visible[mobileIndex].hidden = false;

      if (mobileCounter) {
        mobileCounter.textContent =
          `${mobileIndex + 1} / ${visible.length}`;

        mobileCounter.hidden = visible.length <= 1;
      }
    }

    function resetMobileGallery() {
      mobileIndex = 0;
      renderMobileGallery();
    }

    mobileGallery?.addEventListener('click', (event) => {
      const visible = getVisibleMobileMedia();

      if (visible.length <= 1) return;

      const rect = mobileGallery.getBoundingClientRect();
      const x = event.clientX - rect.left;

      if (x < rect.width / 2) {
        mobileIndex =
          mobileIndex === 0
            ? visible.length - 1
            : mobileIndex - 1;
      } else {
        mobileIndex =
          mobileIndex === visible.length - 1
            ? 0
            : mobileIndex + 1;
      }

      renderMobileGallery();
    });

    groups.forEach((group) => {
      group.addEventListener('click', (event) => {
        const button = event.target.closest('[data-option-value]');

        if (!button) return;

        const index = Number(group.dataset.optionIndex);
        const name = group.dataset.optionName;
        const value = button.dataset.optionValue;

        selected[index] = value;
        setSelectedClass(group, value);

        if (name === 'color') {
          selectedColor = value;

          if (sizeIndex !== null) {
            selected[sizeIndex] = null;

            const sizeGroup = groups.find(
              (item) =>
                Number(item.dataset.optionIndex) === sizeIndex
            );

            if (sizeGroup) {
              sizeGroup
                .querySelectorAll('[data-option-value]')
                .forEach((sizeButton) => {
                  sizeButton.classList.remove('is-selected');
                });
            }
          }

          const label = group.querySelector('[data-color-label]');

          if (label) {
            label.textContent = ` — ${value}`;
          }

          filterGallery();
        }

        updateSizeAvailability();
        updateProductState();

        
      });
    });

    const dialog = root.querySelector('[data-size-guide-dialog]');
    const openGuide = root.querySelector('[data-size-guide-open]');
    const closeGuide = root.querySelector('[data-size-guide-close]');

    openGuide?.addEventListener('click', () => {
      dialog?.showModal();
    });

    closeGuide?.addEventListener('click', () => {
      dialog?.close();
    });

    dialog?.addEventListener('click', (event) => {
      if (event.target === dialog) {
        dialog.close();
      }
    });

    root.querySelectorAll('[data-size-tab]').forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.dataset.sizeTab;

        root.querySelectorAll('[data-size-tab]').forEach((item) => {
          item.classList.toggle(
            'is-active',
            item.dataset.sizeTab === target
          );
        });

        root.querySelectorAll('[data-size-panel]').forEach((panel) => {
          panel.hidden = panel.dataset.sizePanel !== target;
        });
      });
    });

    form?.addEventListener('submit', async (event) => {
      if (!variantInput.value || addButton.disabled) {
        event.preventDefault();
        return;
      }

      event.preventDefault();

      const idleLabel = addButton.textContent;

      addButton.disabled = true;
      addButton.textContent = 'ADDING...';

      try {
        const response = await fetch(
          window.Shopify.routes.root + 'cart/add.js',
          {
            method: 'POST',
            body: new FormData(form)
          }
        );

        if (!response.ok) {
          throw new Error('Cart request failed');
        }

        const cartResponse = await fetch(
          window.Shopify.routes.root + 'cart.js'
        );

        const cart = await cartResponse.json();

        document.querySelectorAll('.ldj-header__bag').forEach((bag) => {
          bag.textContent =
            cart.item_count > 0
              ? `BAG (${cart.item_count})`
              : 'BAG';
        });

        document.dispatchEvent(
          new CustomEvent('ldj:cart-updated', {
            detail: cart
          })
        );

        addButton.textContent = 'ADDED';

        window.setTimeout(() => {
          addButton.textContent = idleLabel;
          addButton.disabled = false;
          updateProductState();
        }, 900);
      } catch {
        addButton.textContent = 'TRY AGAIN';

        window.setTimeout(() => {
          updateProductState();
        }, 1200);
      }
    });

    root
      .querySelectorAll(
        '[data-product-media], [data-mobile-media]'
      )
      .forEach((item) => {
        item.dataset.colorVisible = 'true';
      });

    filterGallery();
    updateSizeAvailability();
    updateProductState();
  };

  const initAllProducts = (root = document) => {
    root.querySelectorAll('[data-product-root]').forEach(initProduct);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      initAllProducts();
    });
  } else {
    initAllProducts();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAllProducts(event.target);
  });
})();
